import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import { Box, Text } from '@components/Restyle';
import Button from '@components/shared/Button/Button';
import Icon from '@components/shared/Icon/Icon';
import theme from '@themes/theme';

interface TeamNoMembersBannerProps {
  onInviteMembers: () => void;
  onDismiss: () => void;
}

export const TeamNoMembersBanner: React.FC<TeamNoMembersBannerProps> = ({
  onInviteMembers,
  onDismiss,
}) => {
  const { t } = useTranslation();

  const inviteButton = () => {
    return (
      <Button
        width={160}
        height={32}
        variant='primary'
        paddingHorizontal='m'
        backgroundColor='black'
        color='white'
        isSmall
        onPress={onInviteMembers}
        accessibilityLabel={t('shared:inviteMembers')}
        prefixMarginRight='xs'
        prefix={<Icon name='UserPlus' width={16} height={16} color='white' />}>
        <Text variant='webSmall' color='white'>
          {t('shared:inviteMembers')}
        </Text>
      </Button>
    );
  };
  return (
    <Box style={styles.container}>
      <Box style={styles.iconContainer}>
        <Icon name='Users' width={24} height={24} color='blue' />
      </Box>
      <Box style={styles.content}>
        <Text variant='labelLargeWeb' color='textPrimary' marginBottom='xxs'>
          {t('shared:teamNoMembersBanner.title')}
        </Text>
        <Text variant='bodySecondary' color='textSecondary' marginBottom='m'>
          {t('shared:teamNoMembersBanner.description')}
        </Text>
        {inviteButton()}
      </Box>
      <Box style={styles.closeButton}>
        <Icon
          name='X'
          width={16}
          height={16}
          color='black'
          onPress={onDismiss}
          accessibilityLabel={t('shared:dismiss')}
        />
      </Box>
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    marginLeft: theme.spacing.m,
    marginRight: theme.spacing.xl,
    marginBottom: theme.spacing.m,
    backgroundColor: theme.colors.blueMild,
    borderRadius: theme.borderRadii.s,
    borderWidth: 1,
    borderColor: theme.colors.blue,
    padding: theme.spacing.m,
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  iconContainer: {
    marginRight: theme.spacing.s,
    marginTop: theme.spacing.xxxs,
    flexShrink: 0,
  },
  content: {
    flex: 1,
  },
  closeButton: {
    marginLeft: theme.spacing.s,
    flexShrink: 0,
    padding: theme.spacing.xxs,
  },
});
